import { render, staticRenderFns } from "./tableAnnualReport.vue?vue&type=template&id=57e947f2&scoped=true"
import script from "./tableAnnualReport.vue?vue&type=script&lang=js"
export * from "./tableAnnualReport.vue?vue&type=script&lang=js"
import style0 from "./tableAnnualReport.vue?vue&type=style&index=0&id=57e947f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e947f2",
  null
  
)

export default component.exports